<div class="page-layout carded fullwidth inner-scroll">
  <div class="center">
    <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
      <span class="h1" [translate]="'APPROVALS_EQUIPMENTS.TITLE'"> Approvals equipments </span>

      <div class="page-buttons" fxHide.xs>
        <button
          *ngIf="filtered"
          mat-stroked-button
          matTooltip="{{ 'APPROVALS_EQUIPMENTS.FILTER_CLEAR' | translate }}"
          (click)="clearFilters()"
        >
          <i class="angularjs-fuse-icon icon-filter-remove"></i>
        </button>

        <button
          mat-stroked-button
          matTooltip="{{ 'APPROVALS_EQUIPMENTS.FILTER.TITLE' | translate }}"
          (click)="sidenavService.open('filterApprovalsEquipments')"
        >
          <i class="angularjs-fuse-icon icon-filter"></i>
        </button>

        <button mat-stroked-button matTooltip="{{ 'APPROVALS_EQUIPMENTS.RELOAD' | translate }}" (click)="reload()">
          <i class="angularjs-fuse-icon icon-reload small"></i>
        </button>
      </div>
    </div>

    <div class="content-card datatable">
      <mat-table
        #datatable
        class="datatable__table"
        [dataSource]="approvals"
        fusePerfectScrollbar
        matSort
        [matSortDisableClear]="true"
      >
        <ng-container matColumnDef="number">
          <mat-header-cell *matHeaderCellDef fxFlex="15" mat-sort-header>
            {{ 'APPROVALS_EQUIPMENTS.HEADER.NUMBER' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let approval" fxFlex="15">
            <span class="limit-cells" [matTooltipShowDelay]="500" [matTooltip]="approval.equipment.number">
              {{ approval.equipment.number }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef fxFlex="20" mat-sort-header>
            {{ 'APPROVALS_EQUIPMENTS.HEADER.NAME' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let approval" fxFlex="20">
            <span class="limit-cells" [matTooltip]="approval.equipment.name" [matTooltipShowDelay]="500">
              {{ approval.equipment.name }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="typeName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'APPROVALS_EQUIPMENTS.HEADER.TYPE' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let approval">
            <span class="limit-cells" [matTooltip]="approval.equipment.type.name" [matTooltipShowDelay]="500">
              {{ approval.equipment.type.name }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="locationName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'APPROVALS_EQUIPMENTS.HEADER.LOCATION' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let approval">
            <span class="limit-cells" [matTooltip]="approval.equipment.location.name" [matTooltipShowDelay]="500">
              {{ approval.equipment.location.name }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'APPROVALS_EQUIPMENTS.HEADER.STATUS' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let approval" [ngClass]="approval.status + '-status-approval-fg'">
            <span class="limit-cells" [matTooltip]="approval.status | statusApprovals" [matTooltipShowDelay]="500">
              {{ approval.status | statusApprovals }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="companyName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'APPROVALS_EQUIPMENTS.HEADER.COMPANY' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let approval">
            <span class="limit-cells" [matTooltip]="approval.company.name" [matTooltipShowDelay]="500">
              {{ approval.company.name }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'APPROVALS_EQUIPMENTS.HEADER.CREATED_AT' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let approval">
            <span
              class="limit-cells"
              [matTooltip]="approval.createdAt | date: 'dd/MM/yyyy HH:mm'"
              [matTooltipShowDelay]="500"
            >
              {{ approval.createdAt | date: 'dd/MM/yyyy HH:mm' }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="edit">
          <mat-header-cell *matHeaderCellDef fxFlex="7">
            {{ 'APPROVALS_EQUIPMENTS.HEADER.ACTIONS' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let approval" fxFlex="7">
            <button
              mat-icon-button
              matTooltip="{{ 'APPROVALS_EQUIPMENTS.VIEW' | translate }}"
              (click)="openDialog(approval)"
            >
              <img src="assets/images/icons/new_icon_edit_action.svg" alt="view approval equipments" />
            </button>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="noData">
          <mat-footer-cell
            *matFooterCellDef
            [attr.colspan]="displayedColumns.length"
            fxLayout="column"
            fxLayoutAlign="center center"
          >
            {{ 'APPROVALS_EQUIPMENTS.NO_DATA' | translate }}
          </mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="loading">
          <mat-footer-cell
            *matFooterCellDef
            [attr.colspan]="displayedColumns.length"
            fxLayout="column"
            fxLayoutAlign="center center"
          >
            <div class="p-24" fxLayout="column" fxLayoutAlign="center center">
              <mat-spinner color="primary" diameter="64" class="mb-24"></mat-spinner>
              {{ 'APPROVALS_EQUIPMENTS.LOADING' | translate }}
            </div>
          </mat-footer-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns" [class.display-none]="loading"></mat-row>
        <mat-footer-row *matFooterRowDef="['noData']" [hidden]="loading || approvals?.length"></mat-footer-row>
        <mat-footer-row *matFooterRowDef="['loading']" [hidden]="!loading || approvals?.length"></mat-footer-row>
      </mat-table>
      <mat-paginator [length]="totalCount" [pageSizeOptions]="[25, 50, 100, 200, 250]"></mat-paginator>
    </div>
  </div>
</div>

<fuse-sidebar name="filterApprovalsEquipments" position="right" lockedOpen="true">
  <filter-approvals-equipments class="sidebar-filter"></filter-approvals-equipments>
</fuse-sidebar>
